<template>
  <div>
    <div class="auto-height">
      <div class="card measure-side-header">
        <div class="card-body" style="padding-left:12px;">
          <h5 class="mb-0">
            {{ $t('administration.users.create.measure_categories_title') }}
          </h5>
          <span class="text-success cursor-pointer" v-if="selectedFilter.id" @click="resetSelected">
            {{ $t('administration.users.create.reset_organization_label') }}
          </span>
        </div>
      </div>

      <div v-for="(object, index) in tableItems"
          :key="'mc_' + index"
          class="filter-tree-item item-block cursor-pointer"
          :class="{'filter-tree-selected': selectedFilter.id == object.id}"
          @click="updateSelected(object)">
        <span class="cursor-pointer" :title="object.name">
          <font-awesome-icon icon="toolbox"/>
          {{ object.name }}
        </span>
      </div>

      <div v-if="!loading && !tableItems.length">
        <div class="card measure-side-header">
          <div class="card-body" style="padding-left:12px;">
            <h5 class="mb-0">
              {{ $t('system.no_results') }}
            </h5>
          </div>
        </div>
      </div>

      <div class="mt-5" v-if="loading">
        <div class="swing-container">
          <div class="swing">
            <div class="swing-l"></div>
            <div></div>
            <div></div>
            <div></div>
            <div class="swing-r"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import roleCheck from "@/util/ACL/roleCheck"

export default {
  name: 'MeasureSideFilter',
  data: function() {
    return {
      loading: true,
      selectedFilter: {},
      tableItems: [],
    }
  },
  props: {
    selectedCategory: {},
    updateList: {},
  },
  watch: {
    getClient: function () {
      this.loadItems();
    },
    selectedFilter: function () {

    },
    updateList: function (newValue, oldValue) {
      if (newValue) {
        this.loadItems()
      }
    },
    // Watcher for selected category - when selected item is changed from external component
    selectedCategory: function (newValue, oldValue) {
      if (newValue) {
        this.updateSelectedFromParent(newValue);
      } else {
        this.resetSelectedWithReload();
      }
    },
    getselectedFilter: function (newValue, oldValue) {
      this.$emit('updateFilter', newValue)
    },

  },
  computed: {
    getClient() {
      return this.$store.state.client
    },
    getselectedFilter() {
      return this.selectedFilter
    }
  },
  methods: {
    loadItems() {
      let self = this;
      this.loading = true;
      piincHttp.get('measure-categories', { params:
        {
          per_page: 100,
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.loading = false;
        self.tableItems = response.data.items;
      }, function() {});
    },

    // Function for updating selected filter - when user clicks on item
    updateSelected(item) {
      if (item && item.id) {
        // If new item is different from the last one
        if (item.id != this.selectedFilter.id) {
          // Select new item and emit event that we updated selected item
          this.selectedFilter = item
          this.$emit('updateSelected', item)
        } else {
          // If new item is same as previous one - deselect the item
          this.resetSelected()
        }
      }
    },

    // Function for updating selected filter - from parent component
    updateSelectedFromParent(item) {
      let self = this;
      if (item && item.id) {
        // First reset previous filter
        this.selectedFilter = {}

        // Then call api to get new data for list (because we changed name on one of them)
        piincHttp.get('measure-categories', { params:
          {
            per_page: 100,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.tableItems = response.data.items;

          // Set selected filter now with new item provided from parent component
          self.selectedFilter = item
          // Emit event that selected item is updated
          self.$emit('updateSelected', item)
        }, function() {});

      }
    },

    resetSelected() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.$emit('updateSelected')
    },
    resetSelectedWithReload() {
      this.selectedFilter = {};
      this.selectedFilterName = '';
      this.loadItems();
      this.$emit('updateSelected');
    }
  },
  created () {
    let self = this;
    if (this.getClient && this.getClient.slug) {
      this.loadItems();
    }
  }
}
</script>
